import React, { useEffect, useState, useCallback } from 'react';
import Loading from '../generalComponets/Loading';
import { useFirestore } from 'react-redux-firebase';
import { DatePicker } from 'react-materialize';
import { triviaQuestionRef } from '../../api/fbCollections';
import M from 'materialize-css';
import Functions from '../../api/Functions';
import { dateToMMDDYYYY, dateToYYYYMMDD, todayToYYYYMMDD } from '../../utils/DateUtil';

function RemoveQuestions() {
  const firestore = useFirestore();
  const [date, setDate] = useState(new Date());
  const [day, setDay] = useState(todayToYYYYMMDD());
  const [selectQuestions, setSelectQuestions] = useState([]);
  const [triviaQuestions, setTriviaQuestions] = useState([]);
  const [showProcess, setShowProcess] = useState(false);
  const [validQuestions, setValidQuestions] = useState(true);
  const [forceUpdate, setForceUpdate] = useState(0);
  const schemeModal = React.createRef();

  const initLoading = () => {
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  };

  useEffect(() => initLoading(), []);

  const getTriviaQuestions = useCallback(() => {
    firestore
      .collection(triviaQuestionRef)
      .orderBy('type', 'asc')
      .get()
      .then((querySnapshot) => {
        const triviaQuestions = [];
        const selectTriviaQuestions = [];
        querySnapshot.forEach((doc) => {
          const triviaQuestion = doc.data();
          triviaQuestions.push(triviaQuestion);
          if (triviaQuestion.day && triviaQuestion.day === day) {
            selectTriviaQuestions.push(triviaQuestion);
          }
        });
        setSelectQuestions(selectTriviaQuestions);
        setTriviaQuestions(triviaQuestions);
        setForceUpdate(fu => fu + 1);
      })
      .catch((e) => {
        console.log('Error get triviaQuestions', e.message)
      });
  }, [firestore, day]);

  useEffect(() => getTriviaQuestions(), [getTriviaQuestions]);

  const selectQuestionsByDate = (day) => {
    const selectQuestions = triviaQuestions.filter((tq) => tq.day === day);
    setSelectQuestions(selectQuestions);
    setForceUpdate(forceUpdate + 1);
  };

  const selectQuestion = (question) => {
    if (selectQuestions.includes(question)) {
      const sQuestions = selectQuestions.filter((q) => q.id !== question.id);
      setSelectQuestions(sQuestions);
      setForceUpdate(forceUpdate + 1);
    } else {
      const sQuestions = selectQuestions;
      sQuestions.push(question);
      setSelectQuestions(sQuestions);
      setForceUpdate(forceUpdate + 1);
    }
  };

  const removeQuestions = async () => {
    try {
      if (selectQuestions.length > 0) {
        setShowProcess(true);
        setValidQuestions(true);
        const promises = [];
        selectQuestions.forEach((sq) => {
          promises.push(Functions.deleteTriviaQuestion(sq));
        });
        await Promise.all(promises);
        setShowProcess(false);
        getTriviaQuestions();
      } else {
        setValidQuestions(false);
      }
    } catch (e) {
      console.log(e.message);
      setShowProcess(false);
    }
  };

  const confirmRemove = () => {
    const modal = M.Modal.getInstance(schemeModal.current);
    modal.open();
  };

  const closeModal = () => {
    const modal = M.Modal.getInstance(schemeModal.current);
    modal.close();
    removeQuestions();
  };

  const renderConfirmModal = () => {
    return (
      <div ref={schemeModal} id="modalScheme" className="modal">
        <div className="modal-content">
          <h5>Confirm Deletion</h5>
          <h6>Are you sure to delete questions?</h6>
          <p>This action will remove ALL data related to these questions the moment it is removed</p>
          <div className="modal-footer">
            <a href="#close" className="modal-close waves-effect btn btn-flat">
              Cancel
            </a>
            <button onClick={closeModal} className="modal-close waves-effect btn btn-flat">
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderQuestion = (question) => {
    return (
      <div className="card">
        <div className="card-content">
          <div className="row">
            <div className="col s8">
              <h6>{question.question}</h6>
              <h6>Type: {question.type}</h6>
              <h6>Day: {question.day}</h6>
            </div>
            <div className="col s2 center">
              <div className="switch">
                <label>
                  <input
                    type="checkbox"
                    checked={selectQuestions.includes(question)}
                    value={selectQuestions.includes(question)}
                    onChange={() => selectQuestion(question)}
                  />
                  <span className="lever" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderQuestions = () => {
    return (
      <div className="scheme-container">
        <div>
          {triviaQuestions.map((q, index) => (
            <div key={index}>{renderQuestion(q)}</div>
          ))}
        </div>
      </div>
    );
  };

  const selectDate = () => (
    <div className="row">
      <div className="col">
        <p>Date: {date != null ? dateToMMDDYYYY(date) : null}</p>
        <p>Day Format: {date != null ? dateToYYYYMMDD(date) : null}</p>
        <DatePicker
          options={{
            defaultDate: date,
          }}
          onChange={(value) => {
            const date = new Date(value);
            date.setHours(0, 0, 0, 0);
            const day = dateToYYYYMMDD(date);
            setDay(day);
            setDate(date);
            selectQuestionsByDate(day);
          }}
        />
      </div>
    </div>
  );

  return (
    <div className="container">
      <h5>Remove Questions</h5>
      {showProcess ? <Loading /> : <div />}
      {renderConfirmModal()}
      <div className="row">
        <div className="col s6">
          {!validQuestions ? <h6 className="red-text">Select Questions</h6> : <div />}
          {selectDate()}
          {renderQuestions()}
        </div>
        <div className="col s6">
          <button className="btn" onClick={confirmRemove}>
            Remove Questions
          </button>
        </div>
      </div>
    </div>
  );
}

export default RemoveQuestions;
